<template>
	<router-view></router-view>
</template>
<script>
import '../static/style/base/base.scss'

export default {
  	name: 'ibroadcast'
}
</script>



// WEBPACK FOOTER //
// src/components/ibroadcast.vue